export type ConnectNetwork = 'mainnet' | 'testnet-clay' | 'dev-unstable'
const CERAMIC_NETWORK: ConnectNetwork =
  process.env.NEXT_PUBLIC_CERAMIC_ENV === 'mainnet' ? 'mainnet' : 'testnet-clay'

export const isProd = () => {
  return CERAMIC_NETWORK == 'mainnet'
}

export const TRIM_REGEXP = /\s+/g

export const OB_ACHIEVEMENT_TYPES = [
  {
    id: 'Achievement',
    text: '達成',
    description: '一般的な達成を表す。',
  },
  {
    id: 'ApprenticeshipCertificate',
    text: '実習修了証',
    description:
      '業界の職種や専門職に適用される基準を満たす、仕事ベースの学習と働きながら学ぶモデルを通じて取得された資格',
  },
  {
    id: 'Assessment',
    text: '評価',
    description:
      '実体、パフォーマンス、または行動の結果の性質、能力、または質の直接的、間接的、形成的、および総括的評価または推定',
  },
  {
    id: 'Assignment',
    text: '課題',
    description: 'カリキュラムの一部または課外の課題や試験の結果を表す。',
  },
  {
    id: 'AssociateDegree',
    text: '準学士号',
    description:
      '通常、中等後教育の最初の1〜2年を修了した学生に授与される大学/大学の学位。UNESCO ISCED 2011のレベル5の学位に相当する',
  },
  {
    id: 'Award',
    text: '賞',
    description: '賞を表す。',
  },
  {
    id: 'Badge',
    text: 'バッジ',
    description:
      'Open Badges仕様に準拠した検証可能な主張を含み、デジタルで配信される視覚的シンボル',
  },
  {
    id: 'BachelorDegree',
    text: '学士号',
    description:
      '通常、3〜5年の教育を修了した学生に授与される大学/大学の学位で、コースワークと活動が最初の1〜2年の大学/大学の学習を超えるスキルを向上させる。UNESCO ISCED 2011のレベル6の学位に相当する。5年間の協同（仕事と学習）プログラムに使用される。協同プランでは、授業出席と事業、産業、または政府での雇用が交互に行われるため、学生は実際の職場経験と大学の学習を組み合わせることができる。また、通常4年の仕事を3年で完了する学士号も含む',
  },
  {
    id: 'Certificate',
    text: '証明書',
    description: '職業、専門職、または学術プログラムに必要な知識とスキルを指定する資格',
  },
  {
    id: 'CertificateOfCompletion',
    text: '課程修了証書',
    description:
      '課題、トレーニング、またはその他の活動の完了を認める資格。活動の記録が存在する場合もしない場合もあり、この資格は別のリソース（資格、評価、または学習機会など）の準備として設計されている場合もそうでない場合もある。',
  },
  {
    id: 'Certification',
    text: '認定',
    description:
      '特定のタスクまたは職業を遂行するための知識、スキル、能力を証明するために、権威ある機関によって授与される期限付き、取り消し可能、更新可能な資格。認定は通常、更新されない場合、倫理規定違反（該当する場合）、または適正な手続きの後に証明された無能力の場合に取り消される可能性がある。',
  },
  {
    id: 'CommunityService',
    text: 'コミュニティサービス',
    description: 'コミュニティサービスを表す。',
  },
  {
    id: 'Competency',
    text: '能力',
    description: '人の成功的な遂行に必要な、測定可能または観察可能な知識、スキル、または能力。',
  },
  {
    id: 'Course',
    text: 'コース',
    description: 'コース修了を表す。',
  },
  {
    id: 'CoCurricular',
    text: '課外活動',
    description: '課外活動を表す。',
  },
  {
    id: 'Degree',
    text: '学位',
    description:
      '通常、大学で複数年にわたるプログラムまたは学習課程の修了時に授与される学術的資格。',
  },
  {
    id: 'Diploma',
    text: 'ディプロマ',
    description:
      '学習課程またはそれに相当するものの成功裡の修了に対して教育機関によって授与される資格。',
  },
  {
    id: 'DoctoralDegree',
    text: '博士号',
    description:
      '学士号と修士号またはそれに相当するものを修了し、さらに独立した研究および/または重要なプロジェクトや論文を完了した学生に対する最高の資格授与。UNESCO ISCED、レベル8に相当する。',
  },
  {
    id: 'Fieldwork',
    text: '実地研修',
    description:
      '学校、大学、または職場から離れて行われる実践的な活動を表す。インターンシップや実習を含む。',
  },
  {
    id: 'GeneralEducationDevelopment',
    text: '一般教育開発',
    description:
      '(GED) 個人が中等教育レベルの学術スキルを習得したことを示す試験によって授与される資格。GED、HiSET、またはTASCなどの州または地域が選択した試験に合格することに基づく高校卒業証書に相当する。またはUNESCO ISCED 2011のレベル2または3の資格に相当する。',
  },
  {
    id: 'JourneymanCertificate',
    text: '職人証明書',
    description:
      '産業の職種や専門職における見習い期間の成功裡の修了に対して熟練労働者に授与される資格。',
  },
  {
    id: 'LearningProgram',
    text: '学習プログラム',
    description: '通常、学位や証明書のような資格につながる一連の学習機会。',
  },
  {
    id: 'Membership',
    text: 'メンバーシップ',
    description: 'メンバーシップを表す。',
  },
  {
    id: 'License',
    text: 'ライセンス',
    description:
      '政府機関または他の認可された組織によって授与される資格で、特定の仕事を行う、および/または特定のアイテム、システム、またはインフラを利用する法的権限を構成する。通常、学位や証明書の取得、認定、評価、実務経験、および/または料金の組み合わせを通じて取得され、期限付きで定期的に更新する必要がある。',
  },
  {
    id: 'ProfessionalDoctorate',
    text: '専門博士号',
    description:
      '専門的な実践に必要な認識、資格、またはライセンスのための知識とスキルを提供するプログラムの修了時に授与される博士号。UNESCO ISCED 2011、レベル8の資格に相当する。',
  },
  {
    id: 'QualityAssuranceCredential',
    text: '品質保証資格',
    description:
      '組織、プログラム、または授与された資格が規定された要件を満たしていることを保証する資格で、資格試験の開発と管理を含む場合がある。',
  },
  {
    id: 'MasterCertificate',
    text: 'マスター証明書',
    description:
      '産業の職種や専門職において、見習いを通じて最高レベルのスキルと性能を実証したことに対して授与される資格。',
  },
  {
    id: 'MasterDegree',
    text: '修士号',
    description:
      '学士号またはそれに相当するものを超えるスキルを向上させる大学院レベルの学習課程に対して授与される資格。UNESCO ISCED 2011のレベル7の資格に相当する。',
  },
  {
    id: 'MicroCredential',
    text: 'マイクロ資格',
    description:
      '特定分野の知識、スキル、または能力の一部を対象とする資格。しばしば他のマイクロ資格や分野の資格との関連性を持つ発展的なもの。',
  },
  {
    id: 'ResearchDoctorate',
    text: '研究博士号',
    description:
      '修士レベルを超える高度な研究を行い、オリジナルの研究に基づく論文や学位論文の作成と防御、または実質的な芸術的もしくは学術的成果を示すオリジナルプロジェクトの計画と実行を含む博士号。UNESCO ISCED 2011のレベル8の資格に相当する。',
  },
  {
    id: 'SecondarySchoolDiploma',
    text: '高等学校卒業証書',
    description:
      '中等教育機関による中等教育プログラムの修了に対して授与される卒業証書。UNESCO ISCED 2011のレベル2または3の資格に相当する。',
  },
]
